<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Editar arquivo'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>
                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5 class="text-xs-left">
                      <v-text-field
                        label="Nome do arquivo"
                        v-model="arquivo.nome"
                        readonly
                       >
                      </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Tipo do arquivo'
                      :items="listaTipoArquivo"
                      v-model="arquivo.tipoArquivo"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      max-height="400"
                      return-object
                      autocomplete
                      required
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between v-if="false">
                  <v-flex xs11 sm5>
                    <v-select
                      label='Nível de acesso'
                      :items="listaNivelAcesso"
                      v-model="arquivo.nivelAcesso"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="vpn_key"
                      max-height="400"
                      autocomplete
                      required
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Tipo de cópia'
                      :items="listaTipoCopia"
                      v-model="arquivo.tipoCopia"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="file_copy"
                      max-height="400"
                      autocomplete >
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Observação"
                      v-model="arquivo.observacao"
                      :rules="assuntoSummaryRules"
                      :rows="2"
                      :auto-grow="true"
                      multi-line
                      counter="200"
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>
              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editarArquivo" :disabled="!formularioValido">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import projetos from '@/utils/projetos'
  import TextArea from '@/components/c-textarea'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idArquivo'],
    data: () => ({
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: undefined,
        nivelAcesso: 'P',
        tipoCopia: 'S'
      },
      listaTipoArquivo: [],
      listaNivelAcesso: [
        {descricao: 'Público', item: 'P'},
        {descricao: 'Restrito', item: 'R'}
      ],
      listaTipoCopia: [
        {descricao: 'Digitalização de cópia simples', item: 'S'},
        {descricao: 'Digitalização de cópia autenticada', item: 'A'},
        {descricao: 'Digitalização do original', item: 'O'}
      ],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ArquivosProjeto', params: {idProjeto: this.idProjeto}})
      },
      adicionarArquivos (arquivos) {
        this.arquivo.conteudo = arquivos[0]
        this.arquivo.nome = arquivos[0].name
      },
      editarArquivo () {
        let body = new FormData()
        body.append('nome', this.arquivo.nome)
        body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item)
        body.append('nivelAcesso', this.arquivo.nivelAcesso)
        body.append('tipoCopia', this.arquivo.tipoCopia)
        body.append('observacao', this.arquivo.observacao)

        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando arquivo.' })
        projetos.putArquivo(this.idProjeto, this.idArquivo, this.arquivo)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ArquivosProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando arquivo.' })
        })
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
        })
      }
    },
    mounted () {
      this.opcoesTabelaEstruturada(1150, this, 'listaTipoArquivo')

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo.' })
      projetos.getArquivo(this.idProjeto, this.idArquivo)
      .then(response => {
        this.arquivo = response.data
        console.log(this.arguivo)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-arquivo.vue?5d0c0a57